module.exports = __webpack_public_path__ + "static/img/002.34e65505.png";